import { PenTool, CreditCard, Calendar, Check, Clock, CheckCircle2, Eye } from "lucide-react"

export const stepsDetail = (patientSignatureRequired) => {
  const completedStep = {
    title: "Patient Review Complete",
    text: "Patient has completed all required steps - ready for admin scheduling",
    description: "The patient process is finished. Admin can now manage the appointment scheduling.",
    btnTitle: "",
    sliderPercentage: 'w-full',
    progressTitle: 'Patient Complete - Admin Review',
    step: patientSignatureRequired ? 'step_4' : 'step_3'
  }

  return {
    decision_step: {
      step: 'step_0'
    },
    payment_step: {
      title: "Acceptance In Progress",
      text: "Patient has signed consent - processing payment",
      description: "Final step in progress - treatment plan will be complete once payment is confirmed",
      btnTitle: "Payment",
      sliderPercentage: 'w-1/2',
      progressTitle: 'Processing Payment',
      step: 'step_2'
    },
    scheduling_step: {
      title: "Ready for Scheduling",
      text: "Patient complete payment - now scheduling treatment appointment",
      description: "Final step: Schedule the treatment appointment to complete the process",
      btnTitle: "Scheduling",
      sliderPercentage: 'w-3/4',
      progressTitle: 'Scheduling Treatment',
      step: patientSignatureRequired ? 'step_3' : 'step_2'
    },
    confirmation_step: completedStep,
    progress_step: completedStep
  }
}

export const stepIcons = (patientSignatureRequired) => {
  return [
    { icon: <Eye size={10} />, label: 'Review', stepNumber: 1 },
    ...(patientSignatureRequired ? [{ icon: <PenTool size={10} />, label: 'Signature', stepNumber: 2 }] : []),
    { icon: <CreditCard size={10} />, label: 'Payment', stepNumber: patientSignatureRequired ? 3 : 2 },
    { icon: <Calendar size={10} />, label: 'Schedule', stepNumber: patientSignatureRequired ? 4 : 3 }
  ]
}

export const acceptanceSteps = [
  {
    id: 1,
    title: "Treatment Plan Review",
    description: "Present treatment plan to patient for review",
  },
  {
    id: 2,
    title: "Sign Consent",
    description: "Present treatment plan to patient for review",
  },
  {
    id: 3,
    title: "Payment Setup",
    description: "Present treatment plan to patient for review",
  },
  {
    id: 4,
    title: "Schedule Treatment",
    description: "Schedule appointment for treatment delivery",
  },
  {
    id: 5,
    title: "Final Confirmation",
    description: "Complete process and provide feedback",
  },
]

export const progressLabels = [
  "Review",
  "Signature",
  "Payment",
  "Schedule",
  "Complete",
]

export const statusIcons = {
  completed: {
    title: "Completed",
    icon: <CheckCircle2 size={20} strokeWidth={2} />,
    className: "bg-green-100 text-green-600",
    fontColor: 'text-green-600',
    statusIcon: <Check size={14} strokeWidth={3} className="text-green-600" />
  },
  in_progress: {
    title: "In Progress",
    icon: <CheckCircle2 size={20} strokeWidth={2} />,
    className: "bg-blue-100 text-blue-600",
    fontColor: 'text-blue-600',
    statusIcon: <Clock size={13} strokeWidth={2} className="text-blue-600" />
  },
  pending: {
    icon: <Clock size={18} strokeWidth={2} />,
    className: "bg-gray-100 text-gray-400"
  }
}

export const getTxpProgress = {
  payment_step: { progress: '30%', completedSteps: 2 },
  scheduling_step: { progress: '58%', completedSteps: 3 },
  progress_step: { progress: '100%', completedSteps: 5 },
  confirmation_step: { progress: '100%', completedSteps: 5 }
}
